import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=13e2e255&"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js&"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports